import { reloadMobileHandler, renderComponent } from '@/utils/tools';
import initOrderForm from '../shared/orderForm';
import initFilters from './filters';
import ObjectsLoader from './loader';

interface CatalogConfig {
  lang: string;
  catalog: {
    id: string;
    type: 'sale' | 'rental';
    selected: Record<string, unknown>;
    options: Record<string, unknown>;
    content: Record<string, unknown>;
  };
  content: {
    order: Parameters<typeof initOrderForm>[0]['content'];
  };
}

export default ({
  lang,
  catalog,
  content
}: CatalogConfig): void => {
  initFilters(lang, catalog);

  renderComponent(ObjectsLoader, {
    lang,
    type: catalog.type,
    selected: catalog.selected
  });

  const onSuccess = () => {
    if (typeof gtag === 'function') {
      gtag('event', 'send_request', { event_category: catalog.type });
    }
  };

  initOrderForm({
    content: content.order,
    onSuccess
  });

  // reload on screen resize
  reloadMobileHandler();
};
